<template>
  <div class="post__list-item d-flex justify-content-between">
    <div class="d-flex flex-wrap flex-sm-nowrap">
      <PublishDisplay
        :post="post"
        :post-schedule="postSchedule"
        :show-badge="showBadge"
        class="pr-4"
      />

      <div class="mr-2">
        <div v-if="isFetching" class="post__thumbnail-skeleton rounded">
          <b-skeleton-img></b-skeleton-img>
        </div>

        <img
          v-else-if="post.meeting"
          :src="require(`@/assets/default-video-cover.jpg`)"
          alt="Default Video Cover"
          class="img-fluid rounded thumbnail img-content"
        />

        <div
          v-else-if="postThumbnailSrc"
          :style="{
            'background-image': `url(${postThumbnailSrc})`
          }"
          class="img-fluid rounded thumbnail img-content-thumbnail"
        ></div>

        <div
          v-else-if="post.vimeo"
          :style="{
            'background-image': `url(${post.vimeo.thumbnail_link})`
          }"
          class="img-fluid rounded thumbnail img-content-thumbnail"
        ></div>

        <!-- <img
          v-else-if="post.vimeo_id"
          :src="require(`@/assets/default-activity-cover.jpg`)"
          alt="Rounded image"
          class="img-fluid rounded thumbnail img-content"
        /> -->

        <!-- <img
          v-else-if="post.images && post.images.length"
          :src="
            post.images && post.images.length
              ? post.images[0].url
              : require(`@/assets/default-activity-cover.jpg`)
          "
          alt="Rounded image"
          class="img-fluid rounded thumbnail img-content"
        /> -->

        <img
          v-else
          :src="require(`@/assets/default-activity-cover.jpg`)"
          alt="default-post-image"
          class="img-fluid rounded thumbnail img-content"
        />
      </div>

      <div
        class="post__list-item-content pl-2 pl-sm-4 d-flex flex-column mt-3 mt-sm-0 justify-content-between"
      >
        <div
          id="post-title"
          class="font-size-lg post__title text__post-title truncate-overflow__post-title"
        >
          {{ postTitle }}
        </div>
        <div class="justify-content-end">
          <div class="d-flex flex-wrap mb-2">
            <b-badge
              v-if="post.is_submission === false && post.meeting === null"
              variant="neutral-dark"
              class="`text-dark mr-2 mb-1 badge__tag-learning"
            >
              Learning
            </b-badge>
            <b-badge
              v-if="post.is_submission === true"
              variant="neutral-primary"
              :class="`text-primary badge__tag-assessment ${
                isEvaluatedByLearningOutcome ? 'mr-2 mb-1' : 'mr-auto'
              }`"
            >
              Assessment
            </b-badge>
            <b-badge
              v-if="isEvaluatedByLearningOutcome"
              :id="`popoverPosition-${post.id}`"
              variant="neutral-primary"
              class="text-primary mb-1 badge__tag-evaluate-lo mr-auto"
            >
              Evaluate learning outcome
            </b-badge>

            <!-- <b-popover
              triggers="hover"
              :target="`popoverPosition-${post.id}`"
              placement="bottomright"
            >
              {{
                learningUnit.learning_outcome
                  ? learningUnit.learning_outcome.description
                  : "No learning outcome"
              }}
            </b-popover> -->
          </div>

          <div v-if="showDate" class="small text-dark">
            Created Date:
            {{ `${formatedDatetime(post.created_at, 'MMM D, YYYY, hh:mma')} ` }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <BaseEllipsis v-if="showOptions" ref="ellipsis" :disabled="disabled">
        <b-dropdown-item class="dropdown-menu__edit" @click.prevent.stop="goToEditPost">
          Edit
        </b-dropdown-item>
        <b-dropdown-item
          class="dropdown-menu__delete"
          :disabled="learningUnit.is_published"
          @click="showModalDeletePost = true"
        >
          Delete
        </b-dropdown-item>
      </BaseEllipsis>
      <ModalDeletePost
        :show.sync="showModalDeletePost"
        :post="post"
        @emitDeletePost="emitDeletePost"
      />
    </div>
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import LearningUnit from '@/models/LearningUnit';
import Post from '@/models/Post';
import PostSchedule from '@/models/PostSchedule';
import Section from '@/models/Section';
import Upload from '@/models/Upload';
import BaseEllipsis from '@/components/base-components/BaseEllipsis';
import ModalDeletePost from '@/views/Post/components/ModalDeletePost';
import PublishDisplay from '@/views/Post/components/PublishDisplay';

export default {
  components: {
    BaseEllipsis,
    ModalDeletePost,
    PublishDisplay
  },
  mixins: [datetimeMixin],

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    post: {
      type: Post,
      required: true
    },

    postSchedule: {
      type: PostSchedule,
      required: true
    },

    section: {
      type: Section,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showBadge: {
      type: Boolean,
      default: true
    },

    showDate: {
      type: Boolean,
      default: true
    },

    showOptions: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isFetching: false,
      showModalDeletePost: false,
      postThumbnailSrc: null
    };
  },

  computed: {
    postTitle() {
      return this.post.title || 'Untitled';
    },

    isEvaluatedByLearningOutcome() {
      return this.post.criterion_ids && this.post.criterion_ids.length;
    }
  },

  async mounted() {
    if (this.post.thumbnail && this.post.thumbnail.length) {
      this.isFetching = true;

      const { response } = await Upload.api().fetchPresignedUrl(this.post.thumbnail[0].id);

      this.postThumbnailSrc = response.data.url;

      this.isFetching = false;
    }
  },

  methods: {
    goToEditPost() {
      if (this.post.meeting !== null) {
        this.$router.push({
          name: 'design-planning/post/edit-video-conference',
          params: {
            learningUnitId: this.learningUnit.id,
            sectionId: this.section.id,
            postId: this.post.id
          },
          query: {
            previousPath: this.$route.fullPath
          }
        });
      } else {
        this.$router.push({
          name: 'design-planning/post/edit',
          params: {
            learningUnitId: this.learningUnit.id,
            sectionId: this.section.id,
            postId: this.post.id
          },
          query: {
            previousPath: this.$route.fullPath,
            view: this.$route.query.view || 'list'
          }
        });
      }
    },

    emitDeletePost(postId) {
      this.$emit('emitDeletePost', postId);
    }
  }
};
</script>

<style lang="scss" scoped>
// .custom-height {
//   height: 100px !important;
// }
.post__thumbnail-skeleton {
  width: 160px;
  height: auto;
  overflow: hidden;
}

.img-content {
  min-width: 160px;
  max-width: 160px;
  height: 100px;
  max-height: max-content;
}

.img-content-thumbnail {
  min-width: 160px;
  max-width: 160px;
  height: 100px;
  background-size: cover;
  background-position: top center;
}

.truncate-overflow__post-title {
  --lh: 1.4rem;
  line-height: var(--lh);
  --max-lines: 2;
  position: relative;
  max-height: calc(var(--lh) * var(--max-lines));
  overflow: hidden;
  padding-right: 1rem; /* space for ellipsis */
}

// @media only screen and (max-width: 1200px) {
//   .img-content {
//     min-width: 200px;
//     max-width: 200px;
//   }
// }

// @media only screen and (max-width: 992px) {
//   .img-content {
//     min-width: 180px;
//     max-width: 180px;
//   }
// }

@media only screen and (max-width: 576px) {
  .img-content {
    min-width: 120px;
    max-width: 120px;
    height: 75px;
  }
  .badge {
    font-size: 55% !important;
  }
}
</style>
